exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* .bodyform-card-heading {\r\n    \r\n} */\r\n\r\n.cpSearchColor{\r\n    color: grey !important;\r\n    font-size: 22px !important;\r\n}\r\n\r\n.cpDetailModal{\r\n    max-width: 800px !important;\r\n}\r\n", ""]);

// exports
